import { useEffect, useState, useMemo } from "react";
import { AgGridReact } from "ag-grid-react";
import { getDocumentRecipients } from "../../services/adminDocuments_service";
import { toast } from "react-toastify";

const RecipientsModal = ({
  show,
  documentId,
  onClose
}) => {

  const [rowData, setRowData] = useState([]);

  const fetchRecipients = async () => {

    try {

      const response = await getDocumentRecipients(documentId);

      setRowData(response.data);

    }
    catch {

      toast.error("Unable to load recipients.");
      setRowData([]);

    }

  };

  useEffect(() => {

    if (documentId) {
      fetchRecipients();
    }

  }, [documentId]);

  if (!show) return null;

  const columnDefs = [

    {
      headerName: "Name",
      field: "sendName",
      flex: 1
    },

    {
      headerName: "Email",
      field: "webUserId",
      flex: 1
    }

  ]

  return (
    <>
      <div className="modal fade in" style={{ display: "block" }}>

        <div className="modal-dialog" style={{ width: "700px" }}>

          <div className="modal-content">

            {/* HEADER */}

            <div className="modal-header" style={{ padding: "0px 0px" }}>

              <button
                type="button"
                className="close"
                onClick={onClose}
              >
                &times;
              </button>

              <h4 className="modal-title" style={{ margin: 0 }}>
                Recipients
              </h4>

            </div>

            {/* BODY */}

            <div
              className="modal-body"
              style={{
                paddingBottom: "20px",
                paddingTop: "20px"
              }}
            >

              <div
                className="ag-theme-alpine"
                style={{ height: 350, width: "100%" }}
              >

                <AgGridReact
                  theme={"legacy"}
                  rowData={rowData}
                  columnDefs={columnDefs}
                  pagination={true}
                  animateRows={true}
                />

              </div>

            </div>

            {/* FOOTER */}

            <div className="modal-footer">

              <button
                className="btn btn-default"
                onClick={onClose}
              >
                Close
              </button>

            </div>

          </div>

        </div>

      </div>
    </>
  );
};

export default RecipientsModal;